import { render, staticRenderFns } from "./DetailedRow.vue?vue&type=template&id=dcd157d8&scoped=true"
import script from "./DetailedRow.vue?vue&type=script&lang=js"
export * from "./DetailedRow.vue?vue&type=script&lang=js"
import style0 from "./DetailedRow.vue?vue&type=style&index=0&id=dcd157d8&prod&lang=css"
import style1 from "./DetailedRow.vue?vue&type=style&index=1&id=dcd157d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd157d8",
  null
  
)

export default component.exports